<template>
  <div style="display: flex; flex-direction: column; height: 100vh;">
  <splitpanes style="height: inherit" class="default-theme">
    <pane min-size="20" id="mainFrame"  class="bg-white">
    <v-row>
      <v-col>
         <h1>Prozesse</h1>
      </v-col>
      <v-col class="text-right" v-if="loadingProgress == 100">
        <v-btn color="primary" medium elevation="0" @click="openFolderDialog()">
          <v-icon color="#F5F5F5" medium>add</v-icon > Neuer Ordner
        </v-btn>
        <v-btn style="margin-left: 20px" color="primary" medium elevation="0" @click="openProcessDialog()">
          <v-icon color="#F5F5F5" medium>add</v-icon > Neues Prozessmodel
        </v-btn>
      </v-col>
    </v-row>

    <FilterComponent :characteristicPresent="checkCharacteristicPresent()" @applyFilter="applyFilter" @resetFilter="resetFilter" @applyTextFilter="applyTextFilter"/>
    <v-tabs left fixed-tabs v-model="tab" color="secondary" v-if="loadingProgress == 100">
      <v-tab id="tab" key="all">Alle Prozesse 
        <!-- <v-chip id="chip" color="white">{{ processes != null ? processes.length : '0'}}</v-chip> -->
        <v-spacer/>
      </v-tab>
      <v-tab id="tab" key="own">Meine Prozesse 
        <!-- <v-chip id="chip" color="white">{{ ownProcesses != null ? ownProcesses.length : '0'}}</v-chip> -->
        <v-spacer/>
      </v-tab>
      <v-tab id="tab" key="shared">Freigegebene Prozesse
        <!-- <v-chip id="chip" color="white">{{ sharedProcesses != null ? sharedProcesses.length : '0'}}</v-chip> -->
        <v-spacer/>
      </v-tab>
      <v-tab id="tab" key="review" v-if="hasProcessesToReview">Zu prüfende Prozesse <v-icon v-if="hasProcessesToReview" color="warning">mdi-alert-circle-outline</v-icon>
        <!-- <v-chip id="chip" color="white">{{ sharedProcesses != null ? sharedProcesses.length : '0'}}</v-chip> -->
        <v-spacer/>
      </v-tab>
    </v-tabs>
    <div style="flex: 1 1 auto;" v-if="loadingProgress == 100">
      <!-- <folder-list :folderHeaders="folderHeader" :folders="folders" :processHeaders="headers" :processItems="retrieveProcessItems()"/> -->
      <v-data-table
        :headers="folderHeader"
        :items="tab === 3 ? reviewProcesses : filteredFolders"
        :expanded.sync="expanded"
        item-key="id"
        
        class="border-bottom padded-table"
      >     
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" style="padding: 0px 0px 0px 0px">
          <ProcessList :processes="item.processes" :folders="folders" :editIndicator="editIndicator" :tab="tab" @viewSurveys="previewSurveys" @reload="retrieveFolders" @deleteProcessModel="deleteProcessModel" @changeProcessFolder="changeProcessFolder" @processCharacteristic="processCharacteristic"/>
        </td>
      </template>

      <template v-slot:item="{index, item, isExpanded, expand}">
            <tr 
               @mouseover="toolsIndex=index" 
               @mouseleave="toolsIndex=null" 
               @click="expand(!isExpanded)"
            >
              <td>
                <v-icon color="secondary">
                  {{ isExpanded ? 'mdi-folder-open' : 'mdi-folder' }}
                </v-icon>
                <a>
                  {{ item.folderName }}
                </a>
              </td>
              <td>
                <div class="pl-5">
                  <v-chip class="chip" color="secondary" text-color="white">{{ getProcessCount(item.processes) }}</v-chip>
                </div>
                
              </td>
              <td>
                <span color="gray_3">
                  <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                          <span class="cursor-default" v-bind="attrs" v-on="on">
                            <v-avatar
                                color="gray_2"
                                size="32"
                                style="color: #fff;"
                            >{{initials(item.createdBy)}}</v-avatar>
                          </span>
                      </template>
                      <span>{{ item.createdBy }}</span>
                    </v-tooltip>
                </span>
              </td>
              <td>
                <span class="date">{{ new Date(item.createdDate).toLocaleString('de-DE', { day: 'numeric', month: 'short', year: 'numeric'}) }}</span>
              </td>
              <td>
                <v-tooltip v-if="item.createdBy == userId" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="gray" small text @click="editFolder(item)" v-bind="attrs" v-on="on">
                      <v-icon>mdi-pencil</v-icon> 
                    </v-btn>
                  </template>
                  <span>Bearbeiten</span>
                </v-tooltip>
                <v-tooltip v-if="item.createdBy == userId" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="gray" small text @click="shareFolder(item)" v-bind="attrs" v-on="on">
                      <v-icon>mdi-folder-upload-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Freigeben</span>
                </v-tooltip>
                <v-tooltip v-if="item.createdBy == userId && item.folderName != 'Default'" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="custom-disabled-button" :disabled="item.processes != null && item.processes.length > 0" color="gray" small text @click="deleteFolder(item)" v-bind="attrs" v-on="on">
                      <v-icon>mdi-folder-remove-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Ordner löschen</span>
                </v-tooltip>
              </td>

            </tr>
          </template> 
      
      </v-data-table>
      
  
    </div>
    <NewProcessModePicker ref="newProcessModePicker" />
    <NewFolderDialog ref="newFolderDialog" />
    <NewProcessDialog v-model="showCreateDialog" :folders="getFoldersForNewProcess(folders)" @linkProcessToFolder="linkProcessToFolder"/>
    <ImportProcessDialog v-model="showImportDialog" :folders="getFoldersForNewProcess(folders)" @linkProcessToFolder="linkProcessToFolder"/>
    <ConfirmDialog ref="confirmDialog" />
    <FolderChooseDialog ref="folderChooseDialog" />
    <NewProcessCharacteristics ref="newCharacteristics" />
    <EditProcessDialog ref="editProcessDialog" />
    </pane>
  
    <pane v-if="viewSurveys">
      <PreviewSurveyProcessModelDialog :surveys="selectedItem.surveys" @closeSurveyView="closeSurveyPreview"/>
    </pane>
  </splitpanes>
  <v-progress-linear
      :style="'position: absolute; bottom: 0; display: '+(loadingProgress == 100 ? 'none;' : 'block; z-index:99;')"
      color="gray accent-4"
      :indeterminate="loadingProgress != 100"
      height="4"
      :value="loadingProgress"
    ></v-progress-linear>
    <folder-share-dialog ref="folderShareDialog"/>
  </div>
  </template>
  
  <script>
  import Vue from "vue";
  import DataTable from '../../components/common/DataTable.vue';
  import NewProcessModePicker from './NewProcessModePicker.vue';
  import NewFolderDialog from './NewFolderDialog.vue'
  import processListService from "./processlist-service";
  import NewProcessDialog from "@/pages/Dashboard/NewProcessDialog";
  import ImportProcessDialog from "@/pages/Dashboard/ImportProcessDialog";
  import { Splitpanes, Pane } from 'splitpanes'
  import PreviewSurveyProcessModelDialog from '../PxQuestionSurvey/PXSurveyPage/PreviewSurveyProcessModelMenu.vue';
  import ConfirmDialog from "@/components/common/ConfirmDialog";
  import folderService from '@/components/folder-service';
  import FolderChooseDialog from './FolderChooseDialog.vue';
  import FolderList from './FolderList.vue';
  import ProcessList from './ProcessList.vue';
  import FolderShareDialog from './FolderShareDialog.vue';
  import processMapService from '@/components/processMapService.js';
  import NewProcessCharacteristics from "../ProcessMap/ProcessCharacteristicsDialog.vue";
  import connectedRessourceService from '@/pages/ProcessModeling/CustomModelingTools/ConnectedRessources/connectedRessourceService.js'
import EditProcessDialog from "./EditProcessDialog.vue";
import processPublishService from "@/components/processPublishService.js";
import FilterComponent from "../../components/FilterComponent.vue";
  export default {
    components: {
    DataTable,
    NewProcessModePicker,
    NewFolderDialog,
    NewProcessDialog,
    ImportProcessDialog,
    Splitpanes,
    Pane,
    PreviewSurveyProcessModelDialog,
    ConfirmDialog,
    FolderChooseDialog,
    FolderList,
    ProcessList,
    FolderShareDialog,
    NewProcessCharacteristics,
    EditProcessDialog,
    FilterComponent
},
    name: "FolderList",
    data() {
      return {
        processes: [],
        noEditor: "No current editor",
        loadingProgress: 0,
        tab: null,
        folderHeader: [
            {
              text: 'Ordnername',
              align: 'start',
              value: 'folderName',
              width: '45%'
            },
            { text: 'Prozesse', value: 'processCount', align: 'start', width: '10%'},
            { text: 'Ersteller', value: 'createdBy', align: 'start', width: '10%' },
            { text: 'Erstellt am', value: 'createdDate', dataType: "Date", align: 'start',  width: '15%'},
            { text: 'Aktionen', value: 'actions', align: 'start'}
        ],
        search: '',
        showCreateDialog: false,
        showImportDialog: false,
        viewSurveys: false,
        selectedItem: null,
        editIndicator: {},
        folders: [],
        filteredFolders: [],
        expanded: [],
        singleExpand: false,
      };
    },
    computed:{
      userId(){
        return this.$store.state.user.username;
      },
      ownProcesses(){
        if(this.processes == null) return [];
        if(this.processes.length > 0){
          return this.processes.filter(elem => elem.isOwn == true);
        }
      },
      sharedProcesses(){
        if(this.processes == null) return [];
        if(this.processes.length > 0){
          return this.processes.filter(elem => elem.isOwn == false);
        }
      },
      userRoles() {
        return this.$store.state.currentUser.roles.map(elem => elem.id);
      },
      reviewProcesses() {
        if (!this.filteredFolders || this.filteredFolders.length === 0) return [];

        return this.filteredFolders.map(obj => ({
          ...obj,
          processes: obj.processes
              ? obj.processes.filter(process => process.reviewRequests && process.reviewRequests.length > 0 &&
                    process.reviewRequests[0].reviewer === this.userId)
              : []
        }));
      },
      hasProcessesToReview(){
      if(this.reviewProcesses == null || this.reviewProcesses.length < 1) return [];
        return this.reviewProcesses.some(obj => {
          return obj.hasOwnProperty('processes') && Array.isArray(obj.processes) && obj.processes.length > 0;
        });
      },
    },
    mounted() {
      this.retrieveFolders();
      this.getFilters();
      let ths = document.querySelectorAll('th>span');
      for (let elem of ths) {
        if (elem.innerHTML.length > 18) {
          elem.parentElement.setAttribute("style", "display:flex;");
          elem.setAttribute("style", "display:flex;max-width:4rem;justify-content:center;align-items:center;");
        }
      }
    },
    methods: {
      nonEmptyFilterCount(filterItems){
       return Object.values(filterItems)
        .filter(item => Array.isArray(item) && item != filterItems.contextFilter) // Filter only arrays
        .flat().length
      },
      openFolderDialog(){
        this.$refs.newFolderDialog.open(false).then(res =>{
          this.retrieveFolders();
        })
      },
      submitFileName(item){
        processListService.editFileName(item.uuid, item.fileName).then(result => {
          this.retrieveFolders();
        })
      },  
      closeSurveyPreview(){
        this.selectedItem = null;
        this.viewSurveys = false;
      },
      openProcessDialog(){
        this.$refs.newProcessModePicker.open().then(res =>{
          if(res == 'IMPORT'){
            this.showImportDialog = true;
          }else if(res == 'NEW'){
            this.showCreateDialog = true;
          }
        })
      },
      getProcessCount(processes){
        if(processes == null || processes.length <= 0) return 0;
        if(this.tab == 0){
          return processes.length;
        }else if(this.tab == 1){
          return processes.filter(elem => elem.isOwn == true).length;
        }else if(this.tab == 2){
          return processes.filter(elem => elem.isOwn == false).length;
        }else if(this.tab == 3){
          return processes.filter(process => process.reviewRequests && process.reviewRequests.length > 0).length;
        }
      
      },
      editModel(val){
        this.$router.push('/modelEdit/'+val.uuid);
      },
      deleteProcessModel(val){
        this.$refs.confirmDialog
                .open(
                  "Prozessmodell löschen",
                  "Wenn Sie das Prozessmodell löschen werden alle damit referenzierten Daten wie Kommentare, Dokumente, Fragen und Umfragen gelöscht. Sind Sie sicher?"
                )
                .then(() => processListService.deleteProcessModel(val.uuid).then(() => this.retrieveFolders()));
      },
      previewSurveys(item){
        this.viewSurveys = true;
        this.selectedItem = item;
      },
      selectItem(item) {
        this.selectedItem = item;
      },
      unSelectItem(item) {
        this.selectedItem = false;
      },
      initials(email){
        let initials = email.substring(0,2).toUpperCase();
        return initials;
      },
      async retrieveFolders(){
        this.loadingProgress = 0;
        this.processes = [];
        await folderService.init();
        let res = await folderService.retrieveFolders();
        if(res.data == null || res.data.length == 0) this.loadingProgress = 100;
        this.folders = res.data;

        console.log(res)
        for(let folder of this.folders){
          
          let processes = folder.processes;
          if(processes != null) {
            for(let elem of folder.processes){
              elem.isOwn = elem.initiator.toLowerCase() == this.userId.toLowerCase();
              this.editIndicator[elem.uuid]= Vue.observable({
                ...this.editIndicator[elem.uuid],
                editFN: false
              });
            }
          }
          this.loadingProgress = 100;
          this.filteredFolders = JSON.parse(JSON.stringify(this.folders));
        }
      },
      changeProcessFolder(item){
          this.$refs.folderChooseDialog.open(this.folders).then(res =>{
            folderService.addProcessToFolder(res, [item.uuid]).then(res => {
              this.retrieveFolders();
            })
          })      
      },
      clickColumn(slotData) {
        const indexRow = slotData.index;
        const indexExpanded = this.expanded.findIndex(i => i === slotData.item);
        if (indexExpanded > -1) {
          this.expanded.splice(indexExpanded, 1)
        } else {
          this.expanded.push(slotData.item);
        }
      },
      itemRowBackground: function (item) {
        return item ? 'highlighted-row' : 'style-2'
      },
      editFolder(item){
        this.$refs.newFolderDialog.open(true, item).then(res =>{
          this.retrieveFolders();
        })
      },
      linkProcessToFolder(data){
        folderService.addProcessToFolder(data.folderId, [data.uuid]);
      },
      shareFolder(folder){
        this.$refs.confirmDialog
          .open(
            "Ordner '"+folder.folderName+"' freigeben",
            "Wenn Sie einen Ordner freigeben werden alle enthaltenen Prozessmodelle freigegeben. Die Ordnerberechtigungen werden hierdurch nicht beeinträchtigt."
          )
          .then(() => {
            this.$refs.folderShareDialog
            .open(folder);

          });
      },
      getFoldersForNewProcess(folders){
       return folders.filter(folder => {
          return folder.folderPermissions.find(perm => this.userRoles.includes(perm.roleId) && perm.folderPermission['PROCESS_WRITE']);
        })
      },
      deleteFolder(folder){
        this.$refs.confirmDialog
                .open(
                  "Ordner löschen",
                  "Möchten Sie den Ordner wirklich unwiederruflich löschen?"
                )
                .then(() => folderService.deleteFolder(folder.id).then(() => this.retrieveFolders()));
      },
      processCharacteristic(item){
        this.$refs.newCharacteristics.open().then(res =>{
          processMapService.addProcessCharacteristic(res).then(res => {
            
          })
        })
      },
      checkCharacteristicPresent(){
        return this.filteredFolders.some(folder => {
          // Check if any process in the folder has a non-null characteristic
          if(folder.processes == null) return false;
          return folder.processes.some(process => process.characteristic !== null);
        });
      },
      getFilters(){
        connectedRessourceService.retrieveConnectedRessources().then((res) => {
          let departments = res.data.filter(elem => elem.type == "DEPARTMENT");
          let systems = res.data.filter(elem => elem.type == "SYSTEM");
          let roles = res.data.filter(elem => elem.type == "ROLE");
          this.contextItems = {
            systems: systems,
            departments: departments,
            roles: roles
          }
        })
      },
      async applyFilter(filterItems){
        this.loadingProgress = 0;
        this.filteredFolders = JSON.parse(JSON.stringify(this.folders));
        this.filteredFolders.forEach(elem => {
            if(elem.processes != null){
              if(filterItems.textFilter != null && filterItems.textFilter != ""){
                elem.processes = elem.processes.filter(e => e.fileName.toUpperCase().includes(filterItems.textFilter.toUpperCase()));
              }
              if(filterItems.processTypeFilter.length > 0){
                elem.processes = elem.processes.filter(elem => {
                  if(elem.characteristic == null) return null;
                  let fieldVal = elem.characteristic.customFields.find(field => field.customField.fieldId == "prozessart");
                  if(fieldVal == null) return null;
                  if(filterItems.processTypeFilter.includes(fieldVal.fieldValue)) return elem;
                  return null;
                });
              }
              if(filterItems.contextFilter.length > 0){
                  elem.processes = elem.processes.filter(elem =>{
                  return  elem.connectedRessources.some(ressource => filterItems.contextFilter.includes(ressource.id)) ||
                      (elem.characteristic != null && (
                        elem.characteristic.involvedRoles.some(role => filterItems.contextFilter.includes(role.id)) ||
                        elem.characteristic.connectedDepartments.some(department => filterItems.contextFilter.includes(department.id)) ||
                        elem.characteristic.systems.some(system => filterItems.contextFilter.includes(system.id)) ||
                        elem.characteristic.department.some(department => filterItems.contextFilter.includes(department.id))
                      ))
                  }
                  );
              }
            }
          })
          this.filteredFolders = this.filteredFolders.filter(elem => elem.processes != null && elem.processes.length > 0)
          this.loadingProgress = 100;
          if(!filterItems.isResetText){
            this.expandAll();
          }
      },
      applyTextFilter(filterItems){
        if(this.nonEmptyFilterCount == 0) this.filteredFolders = JSON.parse(JSON.stringify(this.folders));
        this.filteredFolders = this.filteredFolders.map(folder => ({
            ...folder,
            processes: folder.processes && filterItems.textFilter
                ? folder.processes.filter(process => 
                    process.fileName.toUpperCase().includes(filterItems.textFilter.toUpperCase())
                )
                : folder.processes
        })).filter(folder => folder.processes && folder.processes.length > 0);
        if(filterItems.textFilter == "") this.collapseAll()
      },
      resetFilter(){
        this.filteredFolders = JSON.parse(JSON.stringify(this.folders));
        this.collapseAll();
      },
      editProcess(item){
        let canEdit = item.isOwn;
        this.$refs.editProcessDialog
          .open(item, true, canEdit)
          .then();
        
      },
      expandAll() {
        this.expanded = this.filteredFolders.filter(item => item.processes.length > 0).map(item => item);
      },
      collapseAll() {
        this.expanded = [];
      },
    }
  };
  </script>
  <style scoped>
:deep tr.v-data-table__expanded.v-data-table__expanded__row{
  background-color: var(--v-primary-lighten2) !important;
}
  table{
    margin-top: 0px
  }
  .white{
    color: var(--v-secondary-base) !important;
  }
  .v-tab--active{
    color:initial;
  }
  .v-tab--active > .v-chip{
    background-color: var(--v-secondary-base) !important;
    color: #F5F5F5 !important;
  }
  #tab{
    max-width:unset;
  }
  #tab.active{
    font-size: 10rem;
  }
  .chip{
    margin-left: 10px;
  }
  #chip{
    margin-left: 10px;
  }
  #datatable{
    position: inherit !important;
  }
  :deep td:first-child {
    width: 40vw;
  }
  :deep td:last-child {
    min-width: 180px;
    width: 10vw;
  }
  :deep td:last-child button.v-size--small {
    min-width: unset;
    width: 36px;
  }
  :deep th {
    height: 60px !important;
  }
  
  :deep .sv_q.sv_qstn .table {
    margin-top: 0rem;
  }
  :deep .sv_header__text h3 {
    font-size: 2rem !important;
  }
  :deep .sv_main .sv_container .sv_body .sv_p_root table {
    display: flex;
    flex-direction: column-reverse;
  }
  :deep .sv_main .sv_container .sv_body .sv_p_root table tr {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  :deep .sv_main .sv_container .sv_body .sv_p_root table thead td {
    display: none;
  }
  :deep .sv_main .sv_container .sv_body .sv_p_root table thead tr {
  }
  :deep .sv_main .sv_container .sv_body .sv_p_root table th {
    width: 100%;
    height: 41px !important;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding-left: 3em;
  }
  :deep .sv_main .sv_container .sv_body .sv_p_root table tbody tr {
    height: 60px;
  }
  :deep .sv_main .sv_container .sv_body .sv_p_root table tbody td {
    height: 60px !important;
    padding: 0;
    line-height: 1.3em;
    padding-left: 10px;
  }
  :deep .sv_main .sv_container .sv_body .sv_p_root table tbody td:first-child span {
    height: 60px;
    display: flex;
    align-items: center;
  }
  :deep .sv_qstn label.sv_q_m_label {
    position: unset !important;
    display: flex !important;
    height: 40px;
    padding: 0;
    align-items: center;
  }
  
  /* Error Message */
  :deep .sv_main .sv_q_erbox:not([style*="display: none"]):not([style*="display:none"]) {
    width: 100%;
  }
  .isExpanded {
   background-color: rgba(255,100,9,0.4) 
  }
   .text-start{
    max-width: 50px;
  }
  :deep thead th:first-child {
    border-radius: 0 0 0 0;
  }
  :deep thead th:lsat-child {
    border-radius: 0 0 0 0;
  }
  :deep .col-2{
    max-width: 120px;
    font-size: small;
  }

  .filterField .v-text-field>.v-input__control>.v-input__slot:after, .filterField .v-text-field>.v-input__control>.v-input__slot:before{
    display: none;
  }

.custom-select:hover {
  background-color: #e0e0e0; /* Change the color as per your requirement */
}
  </style>
  